import type { InputParser } from "../types";

interface FloatOptions {
  maxDecimals?: number;
  asString?: boolean;
  max?: number;
  maxDigits?: number;
}

function floatParser(opts?: {
  maxDecimals?: number;
  max?: number;
  maxDigits?: number;
}): InputParser<number | null>;
function floatParser(opts: {
  maxDecimals?: number;
  asString: true;
  max?: number;
  maxDigits?: number;
}): InputParser<string>;
function floatParser(
  opts?: FloatOptions
): InputParser<number | null> | InputParser<string> {
  const maxDecimals = opts?.maxDecimals ?? 2;
  const asString = opts?.asString ?? false;
  const max = opts?.max;
  const maxDigits = opts?.maxDigits;
  const pattern = new RegExp(`^\\d*\\.?\\d{0,${maxDecimals}}$`);

  const validate = (raw: string) => {
    if (raw === "") return true;
    if (!pattern.test(raw)) return false;
    if (maxDigits !== undefined) {
      const digits = raw.replace(/\D/g, "");
      if (digits.length > maxDigits) return false;
    }
    return true;
  };

  const clamp = (num: number) => {
    if (max !== undefined && num > max) return max;
    return num;
  };

  if (asString) {
    return {
      inputMode: "decimal",
      validate,
      parse: (raw) => {
        if (raw === "" || raw === ".") return "";
        if (max === undefined) return raw;
        const num = clamp(parseFloat(raw));
        return isNaN(num) ? "" : String(num);
      },
      format: (value: string) => value,
      toEditable: (value: string) => value,
      cleanup: (raw) => raw.replace(/\.$/, "")
    } as InputParser<string>;
  }

  return {
    inputMode: "decimal",
    validate,
    parse: (raw) => {
      if (raw === "") return null;
      const num = parseFloat(raw);
      if (isNaN(num)) return null;
      return clamp(num);
    },
    format: (value: number | null) => {
      if (value === null) return "";
      return String(value);
    },
    toEditable: (value: number | null) => {
      if (value === null) return "";
      return String(value);
    },
    cleanup: (raw) => raw.replace(/\.$/, "")
  };
}

export { floatParser };
